import urls from "imports/desktopPaths"
import { makeId } from "shared/imports/sharedHelperFunctions"
import { initialBatchSearchifyFilters } from "downloads/profile-download-center-reducer"

import globalActionTypes from "global-action-types"
import profileDownloadCenterActionTypes from "downloads/profile-download-center-action-types"
import { GLOBAL_DATA_KEY, ORGANIZATION_DESIGN_REQUEST } from "downloads/constants/ProfileDownloadCenterConstants"

import { segue } from "global-action-creators"

const ProfileDownloadCenterActionCreators = {
    updateElementDetail: (elementID, detail, value) => ({
        type: profileDownloadCenterActionTypes.UPDATE_ELEMENT_DETAIL,
        elementID,
        detail,
        value,
    }),

    getExtraBillDetails: (elementID, bill_id, detailType, detailKey) => (dispatch) => {
        dispatch({
            type: profileDownloadCenterActionTypes.UPDATE_ELEMENT_DETAIL,
            detail: `${detailKey}Request`,
            value: "sent",
            elementID,
        })
        return DjangIO.app.bill.models.Bill.objects
            .get(bill_id)
            .action(detailType)
            .GET()
            .then((response) => {
                dispatch({
                    type: profileDownloadCenterActionTypes.UPDATE_ELEMENT_DETAIL,
                    detail: detailKey,
                    value: response,
                    elementID,
                })
                dispatch({
                    type: profileDownloadCenterActionTypes.UPDATE_ELEMENT_DETAIL,
                    detail: `${detailKey}Request`,
                    value: "received",
                    elementID,
                })
            })
    },

    getElementDataFromAPI:
        (elementID, getFilter, resource, detailKey = "data", formatFunc = undefined) =>
        (dispatch) => {
            dispatch({
                type: profileDownloadCenterActionTypes.UPDATE_ELEMENT_DETAIL,
                detail: `${detailKey}Request`,
                value: "sent",
                elementID,
            })

            return resource.objects
                .filter(getFilter)
                .GET()
                .then((response) => {
                    dispatch({
                        type: profileDownloadCenterActionTypes.UPDATE_ELEMENT_DETAIL,
                        detail: detailKey,
                        value: formatFunc ? formatFunc(response) : response.objects,
                        elementID,
                    })
                    dispatch({
                        type: profileDownloadCenterActionTypes.UPDATE_ELEMENT_DETAIL,
                        detail: `${detailKey}Request`,
                        value: "received",
                        elementID,
                    })
                })
        },

    postElementDataFromAPI:
        (elementID, postFilter, resource, detailKey = "data", formatFunc = undefined) =>
        (dispatch) => {
            dispatch({
                type: profileDownloadCenterActionTypes.UPDATE_ELEMENT_DETAIL,
                detail: `${detailKey}CreateRequest`,
                value: "sent",
                elementID,
            })
            return resource.objects
                .create(postFilter)
                .POST()
                .then((response) => {
                    dispatch({
                        type: profileDownloadCenterActionTypes.UPDATE_ELEMENT_DETAIL,
                        detail: detailKey,
                        value: formatFunc !== undefined ? formatFunc(response) : [response],
                        elementID,
                    })
                    dispatch({
                        type: profileDownloadCenterActionTypes.UPDATE_ELEMENT_DETAIL,
                        detail: `${detailKey}CreateRequest`,
                        value: "received",
                        elementID,
                    })
                })
        },

    patchElementDataFromAPI:
        (elementID, dataID, patchFilter, resource, detailKey = "data", formatFunc = undefined) =>
        (dispatch) => {
            dispatch({
                type: profileDownloadCenterActionTypes.UPDATE_ELEMENT_DETAIL,
                detail: `${detailKey}PatchRequest`,
                value: "sent",
                elementID,
            })
            return resource.objects
                .get(dataID)
                .update(patchFilter)
                .PATCH()
                .then((response) => {
                    dispatch({
                        type: profileDownloadCenterActionTypes.UPDATE_ELEMENT_DETAIL,
                        detail: detailKey,
                        value: formatFunc !== undefined ? formatFunc(response) : [response],
                        elementID,
                    })
                    dispatch({
                        type: profileDownloadCenterActionTypes.UPDATE_ELEMENT_DETAIL,
                        detail: `${detailKey}PatchRequest`,
                        value: "received",
                        elementID,
                    })
                })
        },

    getElementDataFromAJAX:
        (elementID, customUrl, detailKey = "data", formatFunc = undefined) =>
        (dispatch) => {
            dispatch({
                type: profileDownloadCenterActionTypes.UPDATE_ELEMENT_DETAIL,
                detail: `${detailKey}Request`,
                value: "sent",
                elementID,
            })
            return $.ajax({
                url: customUrl,
                success: (response) => {
                    dispatch({
                        type: profileDownloadCenterActionTypes.UPDATE_ELEMENT_DETAIL,
                        detail: detailKey,
                        value: formatFunc !== undefined ? formatFunc(response) : response,
                        elementID,
                    })
                    dispatch({
                        type: profileDownloadCenterActionTypes.UPDATE_ELEMENT_DETAIL,
                        detail: `${detailKey}Request`,
                        value: "received",
                        elementID,
                    })
                },
                error: (e) => {
                    // console.error(e)
                    dispatch({
                        type: profileDownloadCenterActionTypes.UPDATE_ELEMENT_DETAIL,
                        detail: detailKey,
                        value: { error: e },
                        elementID,
                    })
                    dispatch({
                        type: profileDownloadCenterActionTypes.UPDATE_ELEMENT_DETAIL,
                        detail: `${detailKey}Request`,
                        value: "received",
                        elementID,
                    })
                },
            })
        },

    updateBatchSelectedState: (batchSelectStateName, resource, filter) => (dispatch) => {
        dispatch({
            type: profileDownloadCenterActionTypes.UPDATE_BATCH_SELECT_STATE_NAME,
            batchSelectStateName,
        })
        resource.objects
            .filter(filter)
            .count(true)
            .GET()
            .then((response) => {
                const searchifyFilter = Object.assign({}, initialBatchSearchifyFilters(), {
                    querysetList: [filter],
                    searchifyCount: response,
                })
                dispatch({
                    type: profileDownloadCenterActionTypes.UPDATE_BATCH_SELECT_STATE_FILTERS,
                    filter: searchifyFilter,
                })
            })
    },

    replaceBatchSearchifyFilters: (selection) => ({
        type: profileDownloadCenterActionTypes.REPLACE_BATCH_SEARCHIFY_FILTERS,
        selection,
    }),

    updateModeType: (mode) => ({
        type: profileDownloadCenterActionTypes.UPDATE_MODE_TYPE,
        mode,
    }),

    updateSubModeType: (mode) => ({
        type: profileDownloadCenterActionTypes.UPDATE_SUB_MODE_TYPE,
        mode,
    }),

    updateCurrentPage: (page) => ({
        type: profileDownloadCenterActionTypes.UPDATE_CURRENT_PAGE,
        page,
    }),

    updateCurrentRenderId: (renderID) => ({
        type: profileDownloadCenterActionTypes.UPDATE_CURRENT_PREVIEW_ID,
        renderID,
    }),

    zoomIn: () => ({
        type: profileDownloadCenterActionTypes.ZOOM_IN,
        modifyValue: -1,
    }),

    zoomOut: () => ({
        type: profileDownloadCenterActionTypes.ZOOM_OUT,
        modifyValue: 1,
    }),

    increaseHeight: (elementID, heightAdjustIncrement = 1) => ({
        type: profileDownloadCenterActionTypes.INCREASE_HEIGHT,
        modifyValue: heightAdjustIncrement,
        elementID,
    }),

    decreaseHeight: (elementID, heightAdjustIncrement = 1) => ({
        type: profileDownloadCenterActionTypes.DECREASE_HEIGHT,
        modifyValue: -heightAdjustIncrement,
        elementID,
    }),

    changeText: (key, newText) => ({
        type: profileDownloadCenterActionTypes.CHANGE_TEXT,
        key,
        text: newText,
    }),

    updateTitleSize: (newTitleLength) => ({
        type: profileDownloadCenterActionTypes.UPDATE_TITLE_SIZE,
        titleLength: newTitleLength,
    }),

    removePage: (page) => ({
        type: profileDownloadCenterActionTypes.REMOVE_PAGE,
        page,
    }),

    addPage: (insertPageNum = -1) => ({
        type: profileDownloadCenterActionTypes.ADD_PAGE,
        insertPageNum,
    }),

    repositionElement: (elementID, page, newIndex) => ({
        type: profileDownloadCenterActionTypes.REPOSITION_ELEMENT,
        page,
        elementID,
        newIndex,
    }),

    updateSelectedOrganizationDesignId: (id) => ({
        type: profileDownloadCenterActionTypes.UPDATE_SELECTED_ORGANIZATION_DESIGN_ID,
        id,
    }),

    addElement: (displayElementType, page, insertElementIndex = -1) => ({
        /**
         * although displayElement, displayElementType, and elementID
         * seem a little redundant, they are all necessary and serve
         * different purposes
         *  - displayElement: a javascript closure that refers to the
         *    FUNCTION that renders the component (ex: const PDFTwitterRow)
         *  - displayElementType: the function name as a string
         *      - this is necessary for batch downloading and saving templates
         *      - when these elements are json.stringified and then json.loaded
         *        we lose the reference to the javascript function and need
         *        to be able to refer to it later by its name
         * - elementID: a unique ID to refer to this instance of this element type
         *   later in the store
         **/
        type: profileDownloadCenterActionTypes.ADD_ELEMENT,
        displayElement: displayElementType,
        componentKey: displayElementType.defaultProps.componentKey,
        elementID: `${displayElementType.defaultProps.componentKey}-${makeId()}`,
        page,
        insertElementIndex,
    }),

    removeElement: (elementID, page) => ({
        type: profileDownloadCenterActionTypes.REMOVE_ELEMENT,
        page,
        elementID,
    }),

    loadFromTemplate: (pdfTemplateJSON) => ({
        type: profileDownloadCenterActionTypes.LOAD_PDF_FROM_TEMPLATE,
        pdfTemplateJSON,
    }),

    submitSearchifyFromBatchSelector: ({ searchifyFilters }) => {
        return (dispatch) => {
            // add things specific to the batch selection
            searchifyFilters.for_profile_downloads = true

            // dispatch that searchify was successful to that other
            // features can handle the action
            return dispatch({
                type: profileDownloadCenterActionTypes.SEARCHIFY_SUBMIT_BATCH_SELECTOR,
                filterObj: searchifyFilters,
            })
        }
    },

    submitSearchifyFromPDFSingleObject: ({ searchifyFilters }) => {
        // this is from single searchify so there can only be a single value returned
        const renderID = searchifyFilters.addedIds[0]
        // dispatch update to the render id in the pdf
        return {
            type: profileDownloadCenterActionTypes.UPDATE_CURRENT_PREVIEW_ID,
            renderID,
        }
    },

    submitSearchifyFromPDFStatistics:
        ({ searchifyFilters, id }) =>
        (dispatch) => {
            const filter = { for_searchify: JSON.stringify(searchifyFilters) }

            DjangIO.app.stats.models.StatName.objects
                .filter(filter)
                .all()
                .GET()
                .then((response) => {
                    const addedIds = response.objects.map((obj) => obj.id)
                    // map the response so that the statBoxes render properly
                    const mapAddedDataToDisplayStats = response.objects.map((obj) => ({
                        full_name: obj.full_name,
                        slug_name: obj.slug_name,
                    }))

                    dispatch({
                        type: profileDownloadCenterActionTypes.UPDATE_ELEMENT_DETAIL,
                        elementID: id,
                        detail: "customDisplayStatBoxes",
                        value: mapAddedDataToDisplayStats,
                    })
                    dispatch({
                        type: profileDownloadCenterActionTypes.UPDATE_ELEMENT_DETAIL,
                        elementID: id,
                        detail: "addedIds",
                        value: addedIds,
                    })
                })
        },

    searchifySubmitElementFilter:
        ({ searchifyFilters, id }) =>
        (dispatch, getState) => {
            const searchTerm = getState().search.getIn(["advancedSearch", "searchTerm"])
            console.log("SEARCH TERM IS", searchTerm)
            dispatch({
                type: profileDownloadCenterActionTypes.SEARCHIFY_SUBMIT_ELEMENT_FILTER,
                elementToFilterID: id,
                filterObj: { for_searchify: searchifyFilters },
                searchTerm,
            })
        },

    segueToProfileDownload: (newID, type) => (dispatch, getState) => {
        dispatch({
            type: profileDownloadCenterActionTypes.UPDATE_MODE_TYPE,
            mode: type,
        })
        dispatch({
            type: profileDownloadCenterActionTypes.UPDATE_CURRENT_PREVIEW_ID,
            renderID: newID,
        })
        const prevPageUrl = window.location.pathname + window.location.search

        dispatch({
            type: globalActionTypes.PUSH_PAGE,
            nextPage: { prevPageUrl },
        })
        segue(urls.profileDownload)
    },

    clearBatchSearchifyFilters: () => ({
        type: profileDownloadCenterActionTypes.CLEAR_BATCH_SEARCHIFY_FILTERS,
    }),

    setViewChoice: (choice) => ({
        type: profileDownloadCenterActionTypes.SET_VIEW_CHOICE,
        choice,
    }),

    invalidateOrganizationDesigns: () => ({
        type: profileDownloadCenterActionTypes.UPDATE_ELEMENT_DETAIL,
        elementID: GLOBAL_DATA_KEY,
        detail: ORGANIZATION_DESIGN_REQUEST.dataKey,
        value: undefined,
    }),

    segueToUrl: (url) => segue(url),
}

export default ProfileDownloadCenterActionCreators
